import axios from "axios";
import { setExpiredModalOpen } from "store/features/expiredModalSlice";
import { logout } from "store/features/userSlice";
import store from "store/store";

// Toggle environments
const isProduction = true;

// URLs
const localBaseURL = "http://localhost:5010";
const prodBaseURL = "https://tbcareer-api.vercel.app";

export const baseURL = isProduction ? prodBaseURL : localBaseURL;

export const publicClient = axios.create({
  baseURL: `${baseURL}/api`,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": "tbcareersecrectkey", // Replace with your actual API key
  },
});

export const privateClient = axios.create({
  baseURL: `${baseURL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add interceptor to attach token to privateClient
privateClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("actkn");
  if (token) {
    // Ensure headers exist
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

privateClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.log("🔴 AXIOS INTERCEPTOR TRIGGERED", error?.response?.status);

      store.dispatch(logout());

      store.dispatch(setExpiredModalOpen(true));
      localStorage.removeItem("actkn");
    }

    return Promise.reject(error);
  },
);
